import React from 'react';
import Panel from './Panel';
import PendencieList from '../../components/Panel/Pendencies/PendencieList';




const PendenciesPage = () => {

  return (
    <Panel>
      <div>
        <p className="title_panel_plans">PROPOSTAS PENDENTES</p>
        <PendencieList />
      </div>
    </Panel>

  );
};

export default PendenciesPage;



/** WEBPACK FOOTER **
 ** ./src/containers/Panel/PendenciesPage.js
 **/